import { ReactNode } from 'react';

import { Divider } from '../Divider/Divider';
import { Stack, StackProps } from '../Stack/Stack';
import { cn } from '../utils';

type ActionCardType = 'default';

type ActionCardProps = {
  actionButtons?: ReactNode;
  type?: ActionCardType;
} & StackProps;

export const ActionCard = ({ children, actionButtons, type = 'default', className, ...delegated }: ActionCardProps) => {
  return (
    <Stack
      className={cn(
        'rounded-3xl border border-neutral-black-12 p-6 transition-all duration-200 gap-2 justify-between',
        type === 'default' && 'w-[380px] h-[320px]',
        className,
      )}
      {...delegated}
    >
      {children}
      {actionButtons && (
        <>
          <Divider />
          <Stack direction='row' className='justify-end gap-2'>
            {actionButtons}
          </Stack>
        </>
      )}
    </Stack>
  );
};
